import React, {useState, useEffect} from 'react'
import {Button, Spin, Switch, Select, Form, Input, message, Divider} from 'antd'
import apiRequest from '../hooks/ApiRequest'
import Layouts from '../components/Layouts'

const {Option} = Select

const SubscriptionSettings = () => {
  const [loading, setLoading] = useState(false)
  const [autoDeduction, setAutoDeduction] = useState(false)
  const [subscription, setSubscription] = useState(false)
  const [paymentMethod, setPaymentMethod] = useState('')

  // Fields for Bank Transfer
  const [bankAccountNumber, setBankAccountNumber] = useState('')
  const [bankName, setBankName] = useState('')
  const [ifscCode, setIfscCode] = useState('')
  const [bankEmail, setBankEmail] = useState('')

  // Fields for Card
  const [cardNumber, setCardNumber] = useState('')
  const [cardExpiry, setCardExpiry] = useState('')
  const [cardCVV, setCardCVV] = useState('')
  const [cardName, setCardName] = useState('')

  const UserDetail = JSON.parse(localStorage.getItem('user'))

  useEffect(() => {
    fetchSettings()
  }, [])

  const fetchSettings = async () => {
    setLoading(true)
    try {
      const response = await apiRequest(
        process.env.REACT_APP_BASE_CUST +
          `/Customers/GetCustomerSettingByCustomerId/GetCustomerSetting/${UserDetail?.UserId}`,
      )

      if (response?.success) {
        const {
          autoDeduct,
          paymentMethod,
          subscription,
          bankAccountNumber,
          bankName,
          ifscCode,
          cardNumber,
          cardExpiry,
          cardCVV,
          cardName,
          bankEmail,
        } = response?.data[0] || {}
        setAutoDeduction(autoDeduct)
        setSubscription(subscription)
        setPaymentMethod(paymentMethod)
        setBankAccountNumber(bankAccountNumber || '')
        setBankName(bankName || '')
        setIfscCode(ifscCode || '')
        setBankEmail(bankEmail|| '')

        setCardNumber(cardNumber || '')
        setCardExpiry(cardExpiry || '')
        setCardCVV(cardCVV || '')
        setCardName(cardName || '')
      }
      setLoading(false)
    } catch (err) {
      console.error('Error fetching settings', err)
    }
  }

  const handleSaveSettings = async () => {
    try {
      const res = await apiRequest(
        process.env.REACT_APP_BASE_CUST +
          '/Customers/CreateOrUpdateCustomerSetting/CreateOrUpdateCustomerSetting',
        'POST',
        {
          customerId: UserDetail?.UserId,
          subscription: subscription,
          autoDeduct: autoDeduction,
          paymentMethod: paymentMethod,
          bankAccountNumber,
          bankName,
          ifscCode,
          bankEmail,
          cardNumber,
          cardExpiry,
          cardCVV,
          cardName,
          isDeleted: false,
          isActive: true,
        },
      )

      if (!res?.success) {
        throw new Error(res?.error || 'Failed to update settings')
      }
      message.success('Settings updated successfully!')
    } catch (err) {
      console.error(err)
      message.error('Failed to update settings')
    }
  }

  return (
    <Layouts title="Subscription Settings" classname="dashboard">
      <div className="dash-bg-white" style={{ padding: 20 }}>
        <Divider orientation="left">Manage Your Subscription</Divider>
        <Form layout="horizontal" labelCol={{ span: 8 }} wrapperCol={{ span: 8 }}>
          <Form.Item label="Auto Deduction" wrapperCol={{ offset: 2, span: 4 }}>
            <Switch
              checked={autoDeduction}
              onChange={(checked) => setAutoDeduction(checked)}
            />
          </Form.Item>

          <Form.Item label="Select Payment Method" wrapperCol={{ offset: 2, span: 4 }}>
            <Select
              value={paymentMethod}
              onChange={(value) => setPaymentMethod(value)}
              placeholder="Choose method"
              style={{ width: '100%' }}
            >
              <Option value="Cash">Cash</Option>
              <Option value="BankTransfer">Bank Transfer</Option>
              <Option value="Card">Credit/Debit Card</Option>
            </Select>
          </Form.Item>

          {/* Conditional fields for Bank Transfer */}
          {paymentMethod === 'BankTransfer' && (
            <>
              <Form.Item label="Account Number" wrapperCol={{ offset: 2, span: 4 }}>
                <Input
                  value={bankAccountNumber}
                  onChange={(e) => setBankAccountNumber(e.target.value)}
                />
              </Form.Item>
              <Form.Item label="Bank Name" wrapperCol={{ offset: 2, span: 4 }}>
                <Input
                  value={bankName}
                  onChange={(e) => setBankName(e.target.value)}
                />
              </Form.Item>
              <Form.Item label="IFSC Code" wrapperCol={{ offset: 2, span: 4 }}>
                <Input
                  value={ifscCode}
                  onChange={(e) => setIfscCode(e.target.value)}
                />
              </Form.Item>
              <Form.Item label="Bank associated Email" wrapperCol={{ offset: 2, span: 4 }}>
                <Input
                  value={bankEmail}
                  onChange={(e) => setBankEmail(e.target.value)}
                />
              </Form.Item>
            </>
          )}

          {/* Conditional fields for Card */}
          {paymentMethod === 'Card' && (
            <>
              <Form.Item label="Card Number" wrapperCol={{ offset: 2, span: 4 }}>
                <Input
                  value={cardNumber}
                  onChange={(e) => setCardNumber(e.target.value)}
                />
              </Form.Item>
              <Form.Item label="Expiry Date" wrapperCol={{ offset: 2, span: 4 }}>
                <Input
                  placeholder="MM/YY"
                  value={cardExpiry}
                  onChange={(e) => setCardExpiry(e.target.value)}
                />
              </Form.Item>
              <Form.Item label="CVV" wrapperCol={{ offset: 2, span: 4 }}>
                <Input.Password
                  value={cardCVV}
                  onChange={(e) => setCardCVV(e.target.value)}
                />
              </Form.Item>
              <Form.Item label="Name on Card" wrapperCol={{ offset: 2, span: 4 }}>
                <Input
                  value={cardName}
                  onChange={(e) => setCardName(e.target.value)}
                />
              </Form.Item>
            </>
          )}

          <Form.Item wrapperCol={{ offset: 10, span: 8 }}>
            <Button type="primary" onClick={handleSaveSettings}>
              Save Settings
            </Button>
          </Form.Item>
        </Form>
      </div>

      <Divider />

      {loading ? (
        <Spin
          className="loader-icon-fixed"
          size="large"
          style={{ display: 'block', marginTop: 20 }}
        />
      ) : (
        <div id="divToPrint"></div>
      )}
    </Layouts>
  )
}

export default SubscriptionSettings
